import t from "../../../app/i18n";

export enum CommissionsBatchStep {
  IMPORT = "IMPORT",
  CALCULATION = "CALCULATION",
  RECAPITULATION = "RECAPITULATION",
  REVIEW = "REVIEW",
  FINISH = "FINISH",
}

export enum CommissionOriginType {
  ALL = "ALL",
  CURRENT_BATCH = "CURRENT_BATCH",
  PREVIOUS_BATCHES = "PREVIOUS_BATCHES",
  SPLIT_ADDED = "SPLIT_ADDED",
  MANUALLY_ADDED = "MANUALLY_ADDED",
}

export enum CommissionProcessingResult {
  ALL = "ALL",
  PROCESSED = "PROCESSED",
  WITH_UNMODIFIED_CALCULATION = "WITH_UNMODIFIED_CALCULATION",
  WITH_MODIFIED_CALCULATION = "WITH_MODIFIED_CALCULATION",
  WITH_CALCULATION_ERROR = "WITH_CALCULATION_ERROR",
  POSTPONED = "POSTPONED",
}

export enum CommissionKind {
  INITIAL = "INITIAL",
  INITIAL_DIVIDED = "INITIAL_DIVIDED",
  SUBSEQUENT = "SUBSEQUENT",
  RENEWAL = "RENEWAL",
  INDEXATION = "INDEXATION",
  PREMIUM_CHANGE = "PREMIUM_CHANGE",
  PREPAID_FEE = "PREPAID_FEE",
  PREPAID_EXPRESS_FEE = "PREPAID_EXPRESS_FEE",
  ONGOING_FEE = "ONGOING_FEE",
  ASSET = "ASSET",
  GRADUAL_PAYMENT = "GRADUAL_PAYMENT",
  GRADUAL_ADVANCE_PAYMENT = "GRADUAL_ADVANCE_PAYMENT",
  SAVINGS = "SAVINGS",
  ADDITIONAL_SAVINGS = "ADDITIONAL_SAVINGS",
  BUYOUT = "BUYOUT",
  PURCHASE = "PURCHASE",
  VCN = "VCN",
  SUCCESS = "SUCCESS",
  ETF_SUCCESS = "ETF_SUCCESS",
  TRANSACTION = "TRANSACTION",
  MANAGERIAL = "MANAGERIAL",
  PRF_MANAGERIAL = "PRF_MANAGERIAL",
  ETF_MANAGERIAL = "ETF_MANAGERIAL",
  INITIAL_ELECTRONIC = "INITIAL_ELECTRONIC",
  INITIAL_PAPER = "INITIAL_PAPER",
  CONTRIBUTION_INCREASE = "CONTRIBUTION_INCREASE",
  SECOND_CONTRACT = "SECOND_CONTRACT",
  TRANSFERRED_FUNDS = "TRANSFERRED_FUNDS",
  BONUS = "BONUS",
  BONUS_EXTENDED = "BONUS_EXTENDED",
  UNKNOWN = "UNKNOWN",
}

export enum CommissionType {
  IMPORTED_COMMISSION = "IMPORTED_COMMISSION",
  DUPLICATED_COMMISSION = "DUPLICATED_COMMISSION",
  MANUALLY_ADDED_COMMISSION = "MANUALLY_ADDED_COMMISSION",
  SPLIT_ADDED_COMMISSION = "SPLIT_ADDED_COMMISSION",
}

export enum PostponementReason {
  NOT_FOUND = "NOT_FOUND",
  NOT_VERIFIED = "NOT_VERIFIED",
  DUPLICATE_CONTRACT = "DUPLICATE_CONTRACT",
  IMPORT_ERROR = "IMPORT_ERROR",
  MANUAL = "MANUAL",
  COMMISSION_ADVANCE = "COMMISSION_ADVANCE",
}

export enum CommissionsBatchStepDirection {
  NEXT = "NEXT",
  PREVIOUS = "PREVIOUS",
}

export enum ManualBailAccountMovementsReport {
  ASSOCIATED = "ASSOCIATED",
  DISASSOCIATED = "DISASSOCIATED",
}

export enum CommissionsBatchType {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
}

export const commissionsBatchStepTMap = new Map<CommissionsBatchStep, string>(
  Object.values(CommissionsBatchStep).map((step) => [step, t("commissions.batch.enums.batchStep." + step)]),
);

export const commissionKindTMap = new Map<CommissionKind, string>(
  Object.values(CommissionKind).map((kind) => [kind, t("commissions.batch.enums.commissionKind." + kind)]),
);

export const postponementReasonTMap = new Map<PostponementReason, string>(
  Object.values(PostponementReason).map((reason) => [
    reason,
    t("commissions.batch.enums.postponementReason." + reason),
  ]),
);

export enum BatchPaymentType {
  ALL_GAINERS = "ALL_GAINERS",
  BROKERS = "BROKERS",
  TIPPERS = "TIPPERS",
}

export enum CommissionKindCategory {
  INITIAL = "INITIAL",
  SUBSEQUENT = "SUBSEQUENT",
  RENEWAL = "RENEWAL",
  BONUS = "BONUS",
}
